import Joi from "joi"


export const signInSchema = Joi.object({
    email: Joi.string()
        .email({ tlds: { allow: false } })
        .required().messages({
            'string.email': 'Enter a valid email',
            'any.required': 'Email is required',
            'string.empty': 'Email is required',

        }),
    password: Joi.string().min(5).max(20).required().messages({
        'string.min': 'Password should be at least 5 characters long',
        'string.max': 'Password should be at least 20 characters long',
        'any.required': 'Password is required',
        'string.empty': 'Password is required',
    }),
    rememberMe: Joi.boolean(),
});
